<template>
    <v-container fluid grid-list-md style="margin: 0 !important">
        <v-data-iterator
                :items="payment_details"
                :pagination.sync="pagination"
                @update:pagination="changePage"
                content-tag="v-layout"
                row
                rows-per-page-text="表示件数"
                wrap
        >
            <template v-slot:item="props">
                <v-flex
                        sm12
                        xs12
                >
                    <v-card>
                        <v-card-title class="m-0">
                            <h4>
                                {{ headers.payment_detail.working_day }}：{{ getFormattedDate(props.item.date) }}
                            </h4>
                        </v-card-title>
                        <v-divider class="m-0"></v-divider>
                        <v-list>
                            <!-- 顧客 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>
                                    <h5>
                                        {{ headers.payment_detail.client_name }}:
                                    </h5>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile class="list-small">
                                <v-list-tile-content class="align-end">
                                    <h5>
                                        {{ props.item.client.name }}
                                    </h5>
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 現場 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>
                                    <h5>
                                        {{ headers.payment_detail.site_name }}:
                                    </h5>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile class="list-small">
                                <v-list-tile-content class="align-end">
                                    <h5>
                                        {{ props.item.site.name }}
                                    </h5>
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 出勤区分 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>
                                    <h5>
                                        {{ headers.payment_detail.attendance }}:
                                    </h5>
                                </v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    <h5>
                                        {{ getEnumDescription(
                                        'Arrangement\\AttendanceType',
                                        props.item.attendance_type) }}
                                    </h5>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider class="m-0"></v-divider>
                            <!-- 基本 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.basic_amount }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.basic_amount + props.item.midnight_amount) }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 交通費 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>
                                    {{ headers.payment_detail.transportation_expenses }}:
                                </v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.transportation_expenses) }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider class="m-0"></v-divider>
                            <!-- 残業 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.overtime_amount }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.overtime_amount + props.item.legal_holiday_amount +
                                    props.item.legal_out_holiday_amount) }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 深夜残業 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.midnight_overtime_amount }}:
                                </v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.midnight_overtime_amount +
                                    props.item.legal_holiday_midnight_amount +
                                    props.item.legal_out_holiday_midnight_amount) }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 手当 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.allowance_amount }}:
                                </v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.allowance_site + props.item.allowance_night_shift)
                                    }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- 遅刻 -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.late_amount }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.late_amount) }}
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider class="m-0"></v-divider>
                            <!-- トータル -->
                            <v-list-tile class="list-small">
                                <v-list-tile-content>{{ headers.payment_detail.total_amount }}:</v-list-tile-content>
                                <v-list-tile-content class="align-end">
                                    {{ getFormattedAmount(props.item.total_amount) }}
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-flex>
            </template>
        </v-data-iterator>
    </v-container>
</template>

<script>
    import {EnumsMixin} from '../../../mixins/enums';

    export default {
        name: "SpBusinessDetailComponent",
        mixins: [
            EnumsMixin,
        ],
        props: {
            payment_details: Array
        },
        data() {
            return {
                headers: {
                    payment_detail: {
                        working_day: appUtil.getLang('validation.attributes.payment_detail.working_day'),
                        client_name: appUtil.getLang('validation.attributes.payment_detail.client_name'),
                        site_name: appUtil.getLang('validation.attributes.payment_detail.site_name'),
                        attendance: appUtil.getLang('validation.attributes.payment_detail.attendance'),
                        basic_amount: appUtil.getLang('validation.attributes.payment_detail.basic_amount'),
                        transportation_expenses: appUtil.getLang('validation.attributes.payment_detail.transportation_expenses'),
                        overtime_amount: '種別1',
                        midnight_overtime_amount: '種別2',
                        allowance_amount: '種別3',
                        late_amount: '種別4',
                        total_amount: appUtil.getLang('validation.attributes.payment_detail.total_amount'),
                    }
                },
                pagination: {
                    rowsPerPage: 10
                },
            }
        },
        methods: {
            getFormattedAmount(price) {
                return appUtil.number_format(price);
            },
            getFormattedDate(date) {
                return moment(date).format('YYYY年MM月DD日')
            },
            changePage() {
                $("html,body").animate({scrollTop: 0}, "300");
            }
        }
    }
</script>